// src/components/navbar.tsx
"use client";

import React from "react";
import { ChevronDown, Instagram, X, Youtube, Menu, X as Close } from "lucide-react";

const NAV_MENU = [
  { name: "Music", href: "#music" },
  { name: "Film", href: "#film" },
];

export default function Navbar() {
  const [open, setOpen] = React.useState(false);
  React.useEffect(() => {
    const onResize = () => window.innerWidth >= 960 && setOpen(false);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return (
    <nav
      role="navigation"
      aria-label="Primary"
      className="sticky top-0 z-50 bg-custom-green"
    >
      <div className="container mx-auto relative flex items-center justify-center px-4 py-3">
        <ul className="hidden lg:flex items-center gap-8">
          {NAV_MENU.map(({ name, href }) => (
            <li key={name}>
              <a href={href} className="flex items-center gap-1 font-medium text-white">
                {name}
                <ChevronDown className="h-4 w-4" />
              </a>
            </li>
          ))}
        </ul>

        <div className="absolute right-4 hidden lg:flex items-center gap-4">
          <a href="https://instagram.com/felipeyarns" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <Instagram className="h-5 w-5 text-white" />
          </a>
          <a href="https://x.com/felipeyarns" target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)">
            <X className="h-5 w-5 text-white" />
          </a>
          <a href="https://youtube.com/@felipeyarns" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
            <Youtube className="h-5 w-5 text-white" />
          </a>
        </div>

        <button
          aria-label="Toggle menu"
          className="ml-auto inline-flex lg:hidden text-white"
          onClick={() => setOpen((v) => !v)}
          type="button"
        >
          {open ? <Close className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="container mx-auto border-t border-white/20 px-4 py-4 lg:hidden">
          <ul className="flex flex-col gap-4">
            {NAV_MENU.map(({ name, href }) => (
              <li key={name}>
                <a href={href} className="flex items-center gap-1 font-medium text-white">
                  {name}
                  <ChevronDown className="h-4 w-4" />
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </nav>
  );
}